module.exports = __webpack_public_path__ + "media/images/map/read_more_image-1f831ccc193ed978cb60b141249d7973.svg";